var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"menu"},[_c('div',{staticClass:"menu-item is-ports",on:{"click":function($event){return _vm.onItemClick('ports')}}},[_vm._v("Our Ports")]),_c('div',{staticClass:"menu-item is-finder",on:{"click":function($event){return _vm.onItemClick('finder')}}},[_vm._v("Route Finder")])])
}
var staticRenderFns = []

export { render, staticRenderFns }